import { api } from './api';

export interface ApiKeyInfo {
  id: string;
  keyPrefix: string;
  name: string;
  isActive: boolean;
  lastUsedAt: string | null;
  createdAt: string;
}

export interface GeneratedApiKey extends ApiKeyInfo {
  key: string;
}

export interface AccessTokenInfo {
  accessToken: string;
  user: {
    id: string;
    email: string;
    role: string;
  };
}

class SettingsService {
  async getApiKey(): Promise<ApiKeyInfo | null> {
    const { data } = await api.get('/settings/api-key');
    return data?.data || data;
  }

  async generateApiKey(): Promise<GeneratedApiKey> {
    const { data } = await api.post('/settings/api-key/generate');
    return data?.data || data;
  }

  async regenerateApiKey(): Promise<GeneratedApiKey> {
    const { data } = await api.post('/settings/api-key/regenerate');
    return data?.data || data;
  }

  async getAccessToken(): Promise<AccessTokenInfo> {
    const { data } = await api.get('/settings/access-token');
    return data?.data || data;
  }
}

export const settingsService = new SettingsService();
